import { Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

import { MainLayoutComponent } from './core/layouts/main-layout/main-layout.component';
import { AUTH_ROUTES } from './core/auth';
import { appSelectorGuard } from './core/guards/app-selector.guard';

export const routes: Routes = [
  ...AUTH_ROUTES,
  {
    path: 'select-app',
    canActivate: [autoLoginPartialRoutesGuard],
    loadComponent: () =>
      import('./features/app-selector/app-selector.component').then(
        (m) => m.AppSelectorComponent,
      ),
  },
  {
    path: '',
    canActivate: [autoLoginPartialRoutesGuard, appSelectorGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: 'users',
        loadComponent: () =>
          import('./features/users/users.component').then(
            (m) => m.UsersComponent,
          ),
        data: { title: 'Usuarios' },
      },
      {
        path: 'apps',
        loadComponent: () =>
          import('./features/apps/apps.component').then((m) => m.AppsComponent),
        data: { title: 'Aplicaciones' },
      },
      {
        path: 'teams',
        loadComponent: () =>
          import('./features/teams/teams.component').then(
            (m) => m.TeamsComponent,
          ),
        data: { title: 'Grupos' },
      },
      { path: '', redirectTo: 'users', pathMatch: 'full' },
    ],
  },
];
